/**
 * Devuelve el copy a mostrar bajo "Continuar como X" según el OS del navegador.
 * Es solo un hint visual — la passkey funciona igual independientemente del
 * label. Si no se reconoce el OS, fallback genérico "Passkey".
 *
 * El nombre del modelo concreto (ej. "MacBook Air") no es accesible desde el
 * browser; siempre se completa con "este dispositivo".
 */
export function getBiometricLabel(userAgent: string = navigator.userAgent): string {
  // iOS/iPadOS — Face ID por defecto (los modelos con Touch ID son minoritarios
  // y el copy genérico igual es comprensible).
  if (
    userAgent.includes('iPhone') ||
    userAgent.includes('iPad') ||
    userAgent.includes('iPod')
  ) return 'Face ID · este dispositivo';
  // macOS — Touch ID es el estándar moderno; los Mac sin Touch ID caen igual
  // en passkey por iCloud Keychain, label sigue siendo coherente.
  if (
    userAgent.includes('Mac OS X') ||
    userAgent.includes('Macintosh')
  ) return 'Touch ID · este dispositivo';
  if (userAgent.includes('Windows NT')) return 'Windows Hello · este dispositivo';
  if (userAgent.includes('Android')) return 'Huella · este dispositivo';
  return 'Passkey · este dispositivo';
}

export function useBiometricLabel(): string {
  if (typeof navigator === 'undefined') return 'Passkey · este dispositivo';
  return getBiometricLabel(navigator.userAgent);
}
